import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { DataContextProvider } from './contexts/DataContext';
import { AuthContextProvider } from './contexts/AuthContext';
import ServicesWrapper from './layouts/ServicesWrapper';
import RoutesComponent from './RoutesComponent';
import { SnackbarContextProvider } from './contexts/SnackbarContext';
import { DialogContextProvider } from './contexts/DialogContext';
import 'chartjs-adapter-date-fns';
import {
  Chart as ChartJS,
  CategoryScale,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <SnackbarContextProvider>
    <AuthContextProvider>
      <DataContextProvider>
        <ServicesWrapper>
          <DialogContextProvider>
            <BrowserRouter>
              <RoutesComponent />
            </BrowserRouter>
          </DialogContextProvider>
        </ServicesWrapper>
      </DataContextProvider>
    </AuthContextProvider>
  </SnackbarContextProvider>,
  // </StrictMode>,
);
